import type { QueryKey } from "@tanstack/react-query"

import {
    EUserRole,
    type ICoachingSessionModel,
    type ICoachingSessionsQueryModel,
    type IUserCoachModel,
    type IUserParticipantModel
} from "@/3514/types"
import type { TEmptyCallback } from "@/shared/types/functions"

type TCoachingSessionsModalSimpleProps = {
    sessionsQueryKey: QueryKey
    sessionId: number
}

type TCoachingSessionsCancelModalProps = TCoachingSessionsModalSimpleProps & {
    viewerRole: EUserRole
}

type TCoachingSessionsScheduleAvailableModalProps = {
    sessions: ICoachingSessionModel[]
    sessionsQueryKey: QueryKey
    user: IUserParticipantModel
    participantId: number
}

type TCoachingSessionsTimingSessionModalProps = {
    advanceTimeInHours: number
}

enum ECoachingSessionsApiMode {
    Group = "group",
    Individual = "individual"
}

type TCoachingSessionsEntityIndividualProps = {
    apiMode: ECoachingSessionsApiMode.Individual
    user: IUserParticipantModel
    onMount?: TEmptyCallback
    onQuerySuccess?(queryModel: ICoachingSessionsQueryModel): void
    groupId?: never
    sessionInfoViewerRole: EUserRole
    withSwappableSessions: boolean
    withCancellableSessions: boolean
    withAttendanceMarkableSessions: boolean
    withPostSessionModalOpeners: boolean
    withGiftSessions: boolean
    wrapperClassName?: string
}

type TCoachingSessionsEntityGroupProps = {
    apiMode: ECoachingSessionsApiMode.Group
    user: IUserCoachModel
    onMount?: TEmptyCallback
    onQuerySuccess?(queryModel: ICoachingSessionsQueryModel): void
    groupId: number
    sessionInfoViewerRole: EUserRole
    withSwappableSessions?: never
    withCancellableSessions?: never
    withAttendanceMarkableSessions?: never
    withGiftSessions?: never
    wrapperClassName?: string
}

type TCoachingSessionsEntityProps = TCoachingSessionsEntityIndividualProps | TCoachingSessionsEntityGroupProps

export { ECoachingSessionsApiMode }
export type {
    TCoachingSessionsModalSimpleProps,
    TCoachingSessionsCancelModalProps,
    TCoachingSessionsScheduleAvailableModalProps,
    TCoachingSessionsTimingSessionModalProps,
    TCoachingSessionsEntityProps,
    TCoachingSessionsEntityIndividualProps
}
